import { manipulations } from './utils'
import { client } from './services'

export default function initSync(mods, store) {
  Object
    .values(mods)
    .filter(mod => mod.auto.has('sync'))
    .forEach((mod) => {
      const service = client.getService(mod.serviceName)
      const eventMutations = {
        created: 'add',
        removed: 'remove',
        patched: 'add',
        updated: 'add',
      }

      Object.keys(eventMutations).forEach((eventName) => {
        service.on(eventName, (res) => {
          manipulations[eventMutations[eventName]](mod)(res, store)
        })
      })
    })
}



// WEBPACK FOOTER //
// ./src/store/sync.js